import { api } from './api';

export interface BrandDto {
  id: number;
  name: string;
  logoUrl?: string;
  isFavourite: boolean;
  isActive: boolean;
  createdAt: string;
}

export interface ModelDto {
  id: number;
  brandId: number;
  brandName: string;
  name: string;
  displayName: string;
  isFavourite: boolean;
  isActive: boolean;
  createdAt: string;
}

export interface ProductBrandCompatibilityDto {
  id: number;
  productId: number;
  brandId: number;
  modelId?: number | null;
  brand: {
    id: number;
    name: string;
    logoUrl?: string;
  };
  model?: {
    id: number;
    name: string;
    brandId: number;
  } | null;
  yearFrom?: number | null;
  yearTo?: number | null;
  displayName: string;
  isPrimary: boolean;
  notes?: string;
  isVerified: boolean;
}

// Brands API
export async function fetchBrands(): Promise<BrandDto[]> {
  const { data } = await api.get<BrandDto[]>('/brands');
  return data;
}

export async function fetchBrand(id: number): Promise<BrandDto> {
  const { data } = await api.get<BrandDto>(`/brands/${id}`);
  return data;
}

export async function createBrand(brand: {
  name: string;
  isFavourite?: boolean;
}): Promise<BrandDto> {
  const { data } = await api.post<BrandDto>('/brands', brand);
  return data;
}

export async function updateBrand(id: number, brand: {
  name: string;
  isFavourite?: boolean;
}): Promise<BrandDto> {
  const { data } = await api.put<BrandDto>(`/brands/${id}`, brand);
  return data;
}

export async function deleteBrand(id: number): Promise<void> {
  await api.delete(`/brands/${id}`);
}

// Models API
export async function fetchModels(brandId?: number): Promise<ModelDto[]> {
  const params: any = {};
  if (brandId) params.brandId = brandId;
  
  const { data } = await api.get<ModelDto[]>('/models', { params });
  return data;
}

export async function fetchModel(id: number): Promise<ModelDto> {
  const { data } = await api.get<ModelDto>(`/models/${id}`);
  return data;
}

export async function createModel(model: {
  brandId: number;
  name: string;
  isFavourite?: boolean;
}): Promise<ModelDto> {
  const { data } = await api.post<ModelDto>('/models', model);
  return data;
}

export async function updateModel(id: number, model: {
  brandId?: number;
  name: string;
  isFavourite?: boolean;
}): Promise<ModelDto> {
  const { data } = await api.put<ModelDto>(`/models/${id}`, model);
  return data;
}

export async function deleteModel(id: number): Promise<void> {
  await api.delete(`/models/${id}`);
}

// Product Brand Compatibilities API
export async function fetchProductCompatibilities(productId: number): Promise<ProductBrandCompatibilityDto[]> {
  const { data } = await api.get<ProductBrandCompatibilityDto[]>(`/productbrandcompatibilities/product/${productId}`);
  return data;
}

export async function createCompatibility(compatibility: {
  productId: number;
  brandId: number;
  modelId?: number | null;
  yearFrom?: number | null;
  yearTo?: number | null;
  isPrimary?: boolean;
  notes?: string;
  isVerified?: boolean;
}): Promise<ProductBrandCompatibilityDto> {
  const { data } = await api.post<ProductBrandCompatibilityDto>('/productbrandcompatibilities', compatibility);
  return data;
}

export async function updateCompatibility(id: number, compatibility: {
  modelId?: number | null;
  yearFrom?: number | null;
  yearTo?: number | null;
  isPrimary?: boolean;
  notes?: string;
  isVerified?: boolean;
}): Promise<ProductBrandCompatibilityDto> {
  const { data } = await api.put<ProductBrandCompatibilityDto>(`/productbrandcompatibilities/${id}`, compatibility);
  return data;
}

export async function deleteCompatibility(id: number): Promise<void> {
  await api.delete(`/productbrandcompatibilities/${id}`);
}
